import React, { useEffect, useState } from "react";
import { getConsultations, deleteConsultations } from "../services/firestoreService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import PageHead from "../components/common/PageHead";

const Consultations = () => {
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchConsultations = async () => {
      try {
        const data = await getConsultations();
        setConsultations(data);
      } catch (err) {
        setError("Failed to load consultations.");
      } finally {
        setLoading(false);
      }
    };
    fetchConsultations();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this consultation?")) return;
    try {
      await deleteConsultations(id);
      setConsultations((prev) => prev.filter((c) => c.id !== id));
    } catch (err) {
      setError("Failed to delete consultation.");
    }
  };

  if (loading) return <p className="text-center mt-4">Loading consultations...</p>;
  if (error) return <p className="text-center mt-4 text-red-500">{error}</p>;

  return (
    <>
      <PageHead name="Consultation Submissions" />
      <div className="container mx-auto p-6 max-w-screen-lg">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
            <thead className="bg-gray-200 text-gray-700 text-lg">
              <tr>
                <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Name</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Email</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Phone</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Company</th>
                <th className="border border-gray-600 px-4 py-2 w-2/6">Message</th>
                <th className="border border-gray-600 px-4 py-2 w-1/6">Date</th>
                <th className="border border-gray-600 px-4 py-2 w-1/12">Action</th>
              </tr>
            </thead>

            <tbody>
              {consultations.length > 0 ? (
                consultations.map((consultation, index) => (
                  <tr key={consultation.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
                    <td className="h-20 px-4 border border-gray-600 text-center">{index + 1}</td>
                    <td className="h-20 px-4 border border-gray-600">{consultation.name}</td>
                    <td className="h-20 px-4 border border-gray-600">{consultation.email}</td>
                    <td className="h-20 px-4 border border-gray-600">{consultation.phone}</td>
                    <td className="h-20 px-4 border border-gray-600">{consultation.company}</td>
                    <td className="h-20 px-4 border border-gray-600 break-words max-w-xs">{consultation.projectDetails}</td>
                    <td className="h-20 px-4 border border-gray-600">
                      {new Date(consultation.timestamp?.seconds * 1000).toLocaleDateString()}
                    </td>
                    <td className="h-20 px-4 border border-gray-600 text-center">
                      <button
                        onClick={() => handleDelete(consultation.id)}
                        className="p-2 rounded text-red-500 hover:bg-red-500 hover:text-white"
                        title="Delete Consultation"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">No consultation submissions found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Consultations;
